export const GET_Jewelery_LOADING = "Jewelery/get/laoding";
export const GET_Jewelery_SUCCESS = "Jewelery/get/success";
export const GET_Jewelery_ERROR = "Jewelery/get/error";

// add item  
export const ADD_Jewelery_LOADING = "Jewelery/add/laoding";
export const ADD_JeweleryT_SUCCESS = "Jewelery/add/success";
export const ADD_Jewelery_ERROR = "Jewelery/add/error";

// update  
export const UPDATE_Jewelery_LOADING = "Jewelery/update/laoding";
export const UPDATE_Jewelery_SUCCESS = "Jewelery/update/success";
export const UPDATE_Jewelery_ERROR = "Jewelery/update/error";

// REMOVE  
export const REMOVE_Jewelery_LOADING = "Jewelery/remove/laoding";
export const REMOVE_Jewelery_SUCCESS = "Jewelery/remove/success";
export const REMOVE_Jewelery_ERROR = "Jewelery/remove/error";
export const SORT_JEWELERY="Health/sort"